import React from 'react';
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {v4 as uuidv4} from "uuid";
import './sortableList.css';




export const MultiSortableContext = ({items, setItems, children}) => (
    <DragDropContext onDragEnd={result => {
        const {destination, source} = result;
        if (!destination) return;
        if (
            destination.index === source.index &&
            destination.droppableId === source.droppableId
        ) {
            return;
        }
        const newLists = structuredClone(items);
        const sourceListIndex = newLists.findIndex(e => e.id === source.droppableId);

        const target = newLists[sourceListIndex].types.splice(source.index, 1);

        let targetListIndex = newLists.findIndex(e => e.id === destination.droppableId);

        newLists[targetListIndex].types.splice(destination.index, 0, target[0]);

        setItems(newLists)
    }}>
        {children}
    </DragDropContext>
);


export const SortableContext = ({items, setItems, children}) => (
    <DragDropContext onDragEnd={result => {
        const {destination, source} = result;
        if (!destination) return;
        if (destination.index === source.index) return;
        let newList = [...items];

        newList.splice(source.index, 1);
        newList.splice(destination.index, 0, items[source.index])
        setItems(newList)
    }}>
        {children}
    </DragDropContext>
);

export const SortableList = ({items, renderItem, getId, droppableId}) => (
    <div className="sortList list">
            <Droppable droppableId={droppableId ?? uuidv4()}>
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="items"
                    >
                        {items.map((item, i) => {
                            return (
                                <Draggable
                                    key={getId(item)}
                                    draggableId={getId(item)}
                                    index={i}
                                >
                                    {
                                        (provided, snapshot) => {
                                            const draggingClass = snapshot.isDragging ? ' dragging' : '';
                                            return (
                                                <div
                                                    className={`draggableListItem ${draggingClass}`}
                                                    {...provided.draggableProps}
                                                    ref={provided.innerRef}
                                                    {...provided.dragHandleProps}
                                                >
                                                    {renderItem(item, i, draggingClass)}
                                                </div>
                                            )
                                        }
                                    }
                                </Draggable>
                            )}
                        )}
                        {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
    );

export const SortableListWithContext = ({items, setItems, renderItem, getId}) => (
    <SortableContext
        items={items}
        setItems={setItems}
    >
        <SortableList
            items={items}
            renderItem={renderItem}
            getId={getId}
        />
    </SortableContext>
    );
